import { render } from "./ProjectSingleView.vue?vue&type=template&id=44d58862&scoped=true"
import script from "./ProjectSingleView.vue?vue&type=script&lang=js"
export * from "./ProjectSingleView.vue?vue&type=script&lang=js"

import "./ProjectSingleView.vue?vue&type=style&index=0&id=44d58862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d58862"]])

export default __exports__